import { V3IconChevronDown } from "../Icons";
import { CustomDarkShade } from "../ReusableStyledComponents/FontSetUtilities";
import { SharedInputComponent, SharedInputProps } from "../SharedInputComponent";
import { SelChevPos, V3Sel } from "./V3Select.styles";

import type { JSX } from "react";

interface V3SelectProps extends SharedInputProps, React.InputHTMLAttributes<HTMLSelectElement> {
    options: { value: string | number; text: string | null; icon?: JSX.Element }[];
    disabledOption?: string;
}

export const V3Select = ({
    label,
    isRounded,
    caption,
    error,
    actionText,
    actionClickHandler,
    options,
    value,
    disabledOption,
    tooltipContent,
    tooltipMaxWidth,
    allowUserThemable = false,
    ...rest
}: V3SelectProps) => {
    const hasError = !!error;

    let icon: JSX.Element | undefined;

    if (value) {
        const selOption = options.filter((opt) => opt.value === value)[0];
        if (selOption && selOption.icon) icon = selOption.icon;
    }

    return (
        <SharedInputComponent
            label={label}
            isRounded={isRounded}
            caption={caption}
            icon={icon}
            error={error}
            actionText={actionText}
            actionClickHandler={actionClickHandler}
            hasError={hasError}
            customErrorRightOffset={46}
            tooltipContent={tooltipContent}
            tooltipMaxWidth={tooltipMaxWidth}
            allowUserThemable={allowUserThemable}
        >
            <SelChevPos $allowUserThemable={allowUserThemable} $customDarkShade={CustomDarkShade.Grey35}>
                <V3IconChevronDown />
            </SelChevPos>
            <V3Sel
                {...rest}
                $hasError={hasError}
                $hasIcon={!!icon}
                value={value}
                $allowUserThemable={allowUserThemable}
                $customDarkShade={CustomDarkShade.Grey48}
            >
                {!!disabledOption && (
                    <option value="" defaultValue="">
                        {disabledOption}
                    </option>
                )}
                {options.map((opt) => (
                    <option value={opt.value} key={opt.value}>
                        {opt.text}
                    </option>
                ))}
            </V3Sel>
        </SharedInputComponent>
    );
};
